<template>
  <v-container fluid class="grey lighten-4 py-8">
    <!-- Overlays de carga (sin cambios de lógica) -->
    <v-overlay :value="cargando" fixed z-index="999">
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        <div class="mt-3 white--text font-weight-bold">Realizando pedido...</div>
      </div>
    </v-overlay>

    <v-overlay :value="all_articles?.length == 0" fixed>
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        <div class="mt-3 white--text font-weight-bold">Cargando catálogo...</div>
      </div>
    </v-overlay>
    
    <!-- Barra de búsqueda superior -->
    <v-row justify="center" class="mb-6">
      <v-col cols="12" md="8" lg="6">
        <v-card elevation="2" class="rounded-xl overflow-hidden">
          <v-text-field
            v-model="search"
            label="¿Qué estás buscando?"
            prepend-inner-icon="mdi-magnify"
            flat
            hide-details
            solo
            clearable
            class="search-bar"
          ></v-text-field>
        </v-card>
      </v-col>
    </v-row>

    <!-- Toolbar de acciones -->
    <v-row align="center" justify="center" class="mb-4">
      <v-btn
        v-if="origin == '1'"
        color="primary"
        depressed
        rounded
        class="px-6 mx-2"
        @click="searchNewArticlesDialog = true"
      >
        <v-icon left>mdi-plus-circle-outline</v-icon>
        Buscar nuevos artículos
      </v-btn>

      <v-btn
        v-if="newArticles.length > 0"
        color="error"
        text
        rounded
        @click="eliminarFiltro"
      >
        <v-icon left>mdi-filter-off</v-icon>
        Eliminar Filtro
      </v-btn>
      
      <v-chip v-if="origin == '1'" color="grey lighten-2" class="ml-2 font-weight-medium">
        {{ numArticulos }} productos encontrados
      </v-chip>
    </v-row>

    <!-- LISTADO DE ARTÍCULOS -->
    <v-row justify="center">
      <v-col cols="12" lg="10">
        <v-hover v-for="(item, index) in articles" :key="index" v-slot="{ hover }">
          <v-card
            :elevation="hover ? 6 : 1"
            class="mb-4 transition-swing rounded-lg product-card"
            :class="{'out-of-stock': item.qty_available <= 0}"
          >
            <v-row no-gutters>
              <!-- Imagen del producto -->
              <v-col cols="12" sm="3" md="2" class="pa-4 d-flex align-center justify-center bg-white border-right">
                <v-img
                  v-if="item.image_1920"
                  :src="imageSrc(item)"
                  max-height="140"
                  contain
                  class="rounded-md"
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <v-icon v-else size="80" color="grey lighten-3">mdi-image-off</v-icon>
              </v-col>

              <!-- Detalles del producto -->
              <v-col cols="12" sm="9" md="10" class="pa-4">
                <v-row>
                  <v-col cols="12" md="8">
                    <div class="d-flex align-center mb-1">
                      <span class="text-caption font-weight-bold grey--text text-uppercase tracking-wider">
                        SKU: {{ item.default_code }}
                      </span>
                      <v-divider vertical class="mx-2"></v-divider>
                      <!-- Badge de veces comprado -->
                      <div v-if="item.default_code != 'OBSERVACION'" class="d-flex align-center">
                        <v-progress-circular v-if="item.purchase_count === undefined" indeterminate size="14" width="2" color="primary" class="mr-1"></v-progress-circular>
                        <span class="text-caption blue--text font-weight-bold">
                          {{ item.purchase_count }} compras previas
                        </span>
                      </div>
                    </div>

                    <h3 class="text-h6 font-weight-bold mb-2 primary--text text--darken-2">
                      {{ item.name }}
                    </h3>

                    <!-- Descripción para Observaciones -->
                    <div v-if="item.observacion" class="mb-3 d-flex align-center">
                      <v-chip small color="amber lighten-4" class="mr-2" @click="editDescription(item)">
                        <v-icon x-small left>mdi-pencil</v-icon> Nota personalizada
                      </v-chip>
                      <span class="text-body-2 italic grey--text text--darken-1">{{ item.description }}</span>
                    </div>

                    <div class="d-flex flex-wrap align-center">
                      <v-btn
                        v-if="!item.observacion"
                        text
                        x-small
                        color="primary"
                        class="px-0 mr-4"
                        @click="getFicha(item)"
                      >
                        <v-icon left small>mdi-file-document-outline</v-icon>
                        Ver ficha técnica
                      </v-btn>
                      
                      <v-chip 
                        small 
                        :color="item.qty_available > 0 ? 'success lighten-5' : 'error lighten-5'" 
                        :class="item.qty_available > 0 ? 'success--text' : 'error--text'"
                        class="font-weight-bold"
                      >
                        <v-icon x-small left :color="item.qty_available > 0 ? 'success' : 'error'">
                          {{ item.qty_available > 0 ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                        </v-icon>
                        Stock: {{ item.qty_available }}
                      </v-chip>
                    </div>
                  </v-col>

                  <!-- Precio y Acciones -->
                  <v-col cols="12" md="4" class="text-md-right border-left-md d-flex flex-column justify-center">
                    <div v-if="item.product_price" class="text-h5 font-weight-black mb-4 green--text text--darken-2">
                      {{ item.product_price[0] }}
                    </div>
                    
                    <!-- Selector de cantidad moderno -->
                    <div class="d-flex align-center justify-md-end mb-4">
                      <span class="text-caption mr-2 font-weight-bold">CANTIDAD:</span>
                      <div class="quantity-selector d-flex align-center border rounded-pill px-2 py-1">
                        <v-btn icon x-small @click="substractFromQuantity(item, index + ((currentPage - 1) * itemsPerPage))">
                          <v-icon small>mdi-minus</v-icon>
                        </v-btn>
                        <input 
                          type="text" 
                          v-model.number="old_quantities[index + ((currentPage - 1)  * itemsPerPage)]"
                          class="qty-input text-center"
                          @input="checkQuantity(item, index + ((currentPage - 1) * itemsPerPage))"
                        >
                        <v-btn icon x-small @click="addFromQuantity(item, index + ((currentPage - 1) * itemsPerPage))">
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </div>
                    </div>

                    <!-- Botón Principal -->
                    <v-btn
                      v-if="origin == '1'"
                      :color="item.in_cart ? 'success' : 'primary'"
                      :outlined="!item.in_cart"
                      block
                      depressed
                      class="rounded-pill"
                      @click="addItemToCart(item)"
                      :disabled="!isValidQuantity(item) || item.in_cart"
                    >
                      <v-icon left>{{ item.in_cart ? 'mdi-cart-check' : 'mdi-cart-plus' }}</v-icon>
                      {{ item.in_cart ? 'EN LA CESTA' : 'AÑADIR' }}
                    </v-btn>
                    
                    <v-btn
                      v-else
                      color="error"
                      outlined
                      block
                      class="rounded-pill"
                      @click="removeItemFromCart(item)"
                    >
                      <v-icon left>mdi-cart-remove</v-icon>
                      QUITAR
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <!-- Paginación -->
    <v-row justify="center" class="my-8">
      <v-pagination
        v-model="currentPage"
        :length="totalPages"
        :total-visible="7"
        circle
        color="primary"
        @input="changePage"
      ></v-pagination>
    </v-row>

    <!-- Botón Flotante para Carrito (Solo si hay items y origin 2) -->
    <v-footer v-if="origin == '2'" app inset color="transparent" class="justify-end pa-6">
      <v-btn
        color="success"
        x-large
        rounded
        elevation="8"
        class="px-8 font-weight-bold shadow-lg"
        @click="selectOrderType = true"
        :disabled="!isFormValid"
      >
        <v-icon left large>mdi-check-all</v-icon>
        FINALIZAR PEDIDO
      </v-btn>
    </v-footer>

    <!-- Elegir el tipo de pedido, Pedido o Presupuesto -->
    <v-dialog v-model="selectOrderType" max-width="550px" transition="dialog-bottom-transition">
      <v-card class="rounded-lg">
        <v-toolbar color="primary" dark flat dense>
          <v-toolbar-title class="text-h6">
            <v-icon left>mdi-cart-check</v-icon> Finalizar Orden
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="selectOrderType = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="pt-6">
          <v-form ref="orderForm" v-model="formValid">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="orderReference"
                  label="Referencia del Pedido"
                  placeholder="Ej: PED-2024-001"
                  outlined
                  prepend-inner-icon="mdi-tag-outline"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="userName"
                  label="Usuario Responsable"
                  outlined
                  required
                  :rules="[v => !!v || 'El usuario es obligatorio']"
                  prepend-inner-icon="mdi-account"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="orderNotes"
                  label="Notas adicionales"
                  outlined
                  rows="3"
                  auto-grow
                  prepend-inner-icon="mdi-comment-text-outline"
                  hint="Añade información relevante para el despacho"
                  persistent-hint
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>

          <v-alert v-if="showAlert" type="warning" border="left" text class="mt-4 mb-0" icon="mdi-alert">
            Tenga en cuenta que el precio de los productos **sin stock** podría variar.
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4 bg-grey lighten-5">
          <v-btn text color="grey darken-1" @click="selectOrderType = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed :disabled="!formValid" @click="makeOrder(1)" class="px-4">
            <v-icon left>mdi-file-document-edit-outline</v-icon> Presupuesto
          </v-btn>
          <v-btn color="success" depressed :disabled="disableMakeOrder" @click="makeOrder(2)" class="px-4">
            <v-icon left>mdi-check-bold</v-icon> Confirmar Pedido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Busqueda de nuevos articulos en odoo -->
    <v-dialog v-model="searchNewArticlesDialog" max-width="700px" scrollable transition="dialog-transition">
      <v-card class="rounded-xl">
        <v-card-title class="headline grey lighten-4 py-4">
          <v-icon color="primary" class="mr-2">mdi-magnify-plus</v-icon>
          Explorar Catálogo Externo
        </v-card-title>

        <v-card-text class="pt-6">
          <v-text-field
            v-model="searchQuery"
            label="Buscar artículos en Odoo"
            placeholder="Nombre, referencia o código de barras..."
            filled
            rounded
            clearable
            append-icon="mdi-magnify"
            @click:append="searchNewArticles"
            @keyup.enter="searchNewArticles"
          ></v-text-field>

          <!-- Estado de carga -->
          <div v-if="searchingArticles" class="text-center py-8">
            <v-progress-circular indeterminate color="primary" size="64" width="6"></v-progress-circular>
            <div class="mt-4 text-subtitle-1 grey--text text--darken-1">Consultando base de datos...</div>
          </div>

          <!-- Estado Vacío / No resultados -->
          <v-fade-transition>
            <v-alert
              v-if="!searchingArticles && searchPerformed && newArticles.length == 0"
              type="info"
              text
              prominent
              class="mt-4"
              icon="mdi-database-search"
            >
              No hemos encontrado ningún artículo que coincida con "<strong>{{ searchQuery }}</strong>".
            </v-alert>
          </v-fade-transition>
          
          <!-- Aquí iría la lista de resultados si la tuvieras -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" text large @click="searchNewArticlesDialog = false" class="text-none">
            Cerrar Búsqueda
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Cuadro de diálogo para editar la descripción -->
    <v-dialog v-model="editDialog" max-width="500px">
      <v-card class="rounded-lg">
        <v-card-title class="headline d-flex align-center">
          <v-avatar color="primary lighten-4" size="40" class="mr-3">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-avatar>
          Editar Descripción
        </v-card-title>
        
        <v-card-text class="py-4">
          <v-textarea 
            v-model="editedDescription" 
            label="Descripción del artículo" 
            outlined 
            placeholder="Escriba la nueva descripción aquí..."
            hide-details
            auto-grow
            rows="4"
          ></v-textarea>
        </v-card-text>
        
        <v-card-actions class="pb-4 px-6">
          <v-btn text color="grey darken-1" @click="editDialog = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed class="px-6" @click="saveDescription">
            Actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para elegir que pdf descargar cuando hay mas de uno -->
    <v-dialog v-model="moreThanOnePDF" max-width="450px" persistent>
      <v-card class="rounded-lg elevation-8">
        <v-card-title class="bg-primary text-white py-4 d-flex justify-space-between">
          <div class="d-flex align-center">
            <v-icon dark class="mr-2">mdi-file-multiple</v-icon>
            <span class="text-h6">Documentos Disponibles</span>
          </div>
          <v-btn icon dark small @click="moreThanOnePDF = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-list two-line subheader>
            <v-subheader v-if="pdfList.length > 0">Seleccione el archivo que desea descargar</v-subheader>
            
            <v-list-item-group v-if="pdfList.length > 0" v-model="selectedItem" color="primary">
              <template v-for="(pdf, index) in pdfList">
                <v-list-item
                  :key="index"
                  @click="downloadPDF(pdf)"
                  class="mx-2 my-1 rounded-lg"
                >
                  <v-list-item-avatar color="red lighten-5">
                    <v-icon color="red">mdi-file-pdf-box</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ pdf.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ pdf.file_size || 'Tamaño desconocido' }}</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn icon color="grey darken-1">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="index + 1 < pdfList.length" :key="'div'+index" inset></v-divider>
              </template>
            </v-list-item-group>

            <div v-else class="pa-8 text-center">
              <v-icon size="64" color="grey lighten-2">mdi-file-alert-outline</v-icon>
              <div class="text-h6 grey--text mt-2">No hay archivos</div>
            </div>
          </v-list>
        </v-card-text>

        <v-card-actions class="justify-center grey lighten-4 py-3">
          <v-btn @click="moreThanOnePDF = false" text color="grey darken-2">
            Cerrar ventana
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- respuesta de realizar pedido -->
    <v-dialog
      v-model="dialog"
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-alert :type="alertType">
        <v-row
          align="center"
          no-gutters
        >
          <v-col class="grow">
            {{ error_text }}
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col class="shrink">
            <v-btn
              outlined
              @click="dialog = false"
            >
              Cerrar
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-dialog>
  </v-container>
</template>
<script>
import moment from "moment";
import { mapState, mapGetters, mapActions } from "vuex";
import { jwtDecode } from "jwt-decode";

export default {
  components: {},

  props: {
    origin: String, // 1 - Home page, 2 - Shopping cart
  },

  data() {
    return {
      search: null,
      old_quantities: [],
      rules: {
        required: (value) => typeof value === "number" || "Obligatorio",
        max: (value, max) => value <= max || `Stock Insuficiente`,
        integer: (value) => Number.isInteger(value) || "Debe ser un número entero",
      },
      isFormValid: true,
      
      cargarPrimero: 0,
      cargarUltimo: 20,
      
      numArticulos: 0,

      //formato paginado
      currentPage: 1,
      itemsPerPage: 20,
      totalPages: 1,

      //Dialog mostrar exito de pedido
      dialog: false,
      error_text: "",
      alertType: "",

      cargando: false,

      //Dialog de realizar pedido
      formValid: false,
      orderReference: "",
      orderNotes: "",
      userName: "",
      selectOrderType: false,

      //Dialog de busqueda de articulos en odoo
      searchNewArticlesDialog: false,
      searchQuery: "",
      searchPerformed: false,
      searchingArticles: false,
      newArticles: [],

      //Dialogo de lista de pdf en ficha articulo
      moreThanOnePDF: false,
      pdfList: [],

      //Dialogo de descripcion
      editDialog: false,
      editedDescription: '',
      selectedItem: null
    };
  },

  computed: {
    ...mapState(["all_articles", "user"]),
    //Listado de articulos mostrados en pantalla
    articles() {
      // pantalla de pedidos
      if (this.origin == "1") {
        //filtrar por busqueda
        if (this.search !== "" && this.search !== null) {
          let names = this.all_articles?.filter((e) => e.name.toUpperCase().includes(this.search.toUpperCase()));
          let ids = this.all_articles?.filter((e) => {
            return (
              typeof e.default_code === "string" && e.default_code.toUpperCase().includes(this.search.toUpperCase())
            );
          });

          return this.createArticles([...names, ...ids]);
        //sin filtro, devolvemos todos los articulos
        } else return this.newArticles.length > 0 ? this.createArticles(this.newArticles) : this.createArticles(this.all_articles);
        //pantalla del carrito
      } else return this.articlesInCart();
    },

    disableMakeOrder() {
      return !this.formValid ||
        //comprobar si hay observacion
        this.articlesInCart().some((art) => art.observacion);
    },
    showAlert(){
      return this.articlesInCart().some((art) => art.qty_available == 0);
    },
  },
  mounted() {
    this.userName = jwtDecode(localStorage.getItem("token")).username;
    this.old_quantities =
      this.origin == "1" ? this.all_articles?.map((a) => a.quantity) : this.articlesInCart().map((a) => a.quantity);
  },
  watch: {
    search() {
      //reestablecemos los valores predeterminados de la paginacion
      this.currentPage = 1;
    },
  },

  methods: {
    ...mapGetters(["articlesInCart", "getPartnerId"]),
    ...mapActions(["postDataWithReturn", "addToCart", "removeFromCart", "setOrders", "changeNewOrder", "clearCart", "addArticle"]),

    getCantPurchased(createdArticles){
      try{
        createdArticles.forEach((art) => {
          if(art.default_code != "OBSERVACION" && !art.searching) {
            const payload = {
              product_id: art.id,
              // partner_id: 70, //borrar
              partner_id: this.getPartnerId(),
              quantity:1,
              date: moment().format("YYYY-MM-DD")
            };
            // console.log(payload);
            this.postDataWithReturn({ path: "django/portal/get_purchase_count/", body: payload }).
              then((cant) => {
                this.$set(art, 'purchase_count', cant.purchase_count);
              }).
              catch((e) => {
                console.error("Error al recoger cantidad del articulo", e);
              });
              //busqueda del precio para el cliente desde landoo
              //creamos campo de buscando para evitar que vuelva a buscar
              this.$set(art, 'searching', true);
            // this.postDataWithReturn({ path: "django/portal/get_product_price/", body: payload }).
            //   then((cant) => {
            //     this.$set(art, 'product_price', cant.price);
            //   }).
            //   catch((e) => {
            //     console.error("Error al recoger precio del articulo", e);
            //   });
            //   //busqueda del precio para el cliente desde landoo
            //   //creamos campo de buscando para evitar que vuelva a buscar
            //   this.$set(art, 'searching', true);
          }
        });
        this.cantSearched = true;
      } catch(e) {
        console.error("Erorr al recoger veces comprada de articulos", e);
      }
    },

    //Funcion para cargar ficha tecnica del producto
    async getFicha(item){
      // console.log(item);
      const { attachments : articleData } = await this.postDataWithReturn({ path: "django/portal/get_article_data/", body: item.id });
      if (articleData) {
        // console.log(articleData);
        if (articleData.length == 1) this.downloadPDF(articleData[0]);
        else {
          this.pdfList = articleData;
          this.moreThanOnePDF = true;
          // console.log("mas de un archivo");
        }
      } else {
        console.log("No se ha encontrado ficha tecnica para el articulo ", item.name);
        this.dialog = true;
        this.error_text = "No se ha encontrado ficha técnica para el artículo";
        this.alertType = "error";
      }
    },
    //Funcion para descargar el pdf
    downloadPDF(attachment){
      try {
        const byteCharacters = atob(attachment.datas);
        const byteNumbers = new Array(byteCharacters.length);
  
        for (let i = 0; i < byteCharacters.length; i ++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
  
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { typ: attachment.mimetype });
  
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = attachment.name;
  
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch(e) {
        console.error("error al descargar pdf de ficha tecnica:", e);
        this.dialog = true;
        this.error_text = "Error al descargar PDF";
        this.alertType = "error";
      }
    },

    //Funciones para cambiar descripcion de articulo observacion
    editDescription(item) {
      this.selectedItem = item;
      this.editedDescription = item.description || ''; // Si no tiene descripción, dejar vacío
      this.editDialog = true;
    },
    saveDescription() {
      if (this.selectedItem) {
        this.selectedItem.description = this.editedDescription;
      }
      this.editDialog = false;
      this.editedDescription = "";
    },

    //Funcion para buscar nuevos articulos en la tienda de odoo
    async searchNewArticles(){
      console.log("buscando nuevos articulos en tienda odoo", this.searchQuery);
      this.searchingArticles = true;
      this.searchPerformed = true;
      const payload = { product_identifier: this.searchQuery };
      try {
        const { products: products } = await this.postDataWithReturn({ path: "django/portal/search_product/", body: payload });
        
        this.newArticles = products.map((a) => ({ quantity: a.qty_available > 0 ? 1 : 0, in_cart: false, ...a }));
        // console.log(this.newArticles);

        if (this.newArticles.length > 0) this.searchNewArticlesDialog = false;

        //añadimos los productos buscados a la lista de articulos para poder enviarlos al carrito
        this.addArticle(this.newArticles);

      } catch(e){
        console.error("error al bsucar nuevos productos");
        this.dialog = true;
        this.error_text = "Error al recoger nuevos artículos";
        this.alertType = "error";
      } finally {
        this.searchingArticles = false;
      }
    },

    //Funcion para eliminar el filtro de busqueda
    eliminarFiltro(){
      this.newArticles = []
      this.searchQuery = "";
    },

    //funcion para devolver el tamaño de pagina de articulos y pagina de articulos
    createArticles(array) {
      // console.log("createarray", array);
      this.numArticulos = array.length;

      //calculamos el total de paginas
      this.totalPages = Math.ceil(array.length / this.itemsPerPage);

      //cargamos old_quantities con los nuevos articulos
      this.old_quantities = array.map((a) => a.quantity);

      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;

      const createdArticles = array.slice(start, end);

      //recogemos las veces compradas de cada producto mostrado
      this.getCantPurchased(createdArticles);

      return createdArticles;
    },

    //Funciones para comprobar reglas de cantidad de los articulos
    checkQuantity(item, index) {
      if (this.old_quantities[index] < 1 || !Number.isInteger(this.old_quantities[index])) {
        this.old_quantities[index] = item.quantity; // Revert to correct value
      } else {
        item.quantity = this.old_quantities[index]; // Update to new valid value
      }
    },

    isValidQuantity(item) {
      // return item.quantity >= 1 && Number.isInteger(item.quantity);
      return item.quantity >= 1 && Number.isInteger(item.quantity);
    },

    //reducir cantidad de articulo
    substractFromQuantity(item, index) {
      // console.log(index);
      if (this.old_quantities[index] > 1) {
        this.old_quantities[index] -= 1;
        item.quantity = this.old_quantities[index];
      }
    },

    //añadir cantidad de articulo
    addFromQuantity(item, index) {
      // console.log(index);
      // if (this.old_quantities[index] < item.qty_available) {
      this.old_quantities[index] += 1;
      item.quantity = this.old_quantities[index];
      // }
    },

    //añadir articulo al carrito
    addItemToCart(item) {
      this.addToCart(item);
    },

    //eliminar articulo del carrito
    removeItemFromCart(item) {
      this.removeFromCart(item);
    },

    //Funcion para cambiar de pagina
    changePage(page) {
      // console.log("page", page);
      this.currentPage = page;
      this.scrollToTop();
    },

    //Funcion para scrollear a la parte de arriba de la aplicacion al cambiar de pagina
    scrollToTop() {
      const forceScrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      };

      forceScrollToTop();

      // Forzar un ajuste después de un retraso
      setTimeout(() => {
        forceScrollToTop();
      }, 300);

      // Usar requestAnimationFrame para precisión adicional
      const smoothScroll = () => {
        if (window.scrollY > 0) {
          forceScrollToTop();
          requestAnimationFrame(smoothScroll);
        }
      };
      requestAnimationFrame(smoothScroll);
    },

    //Funcion para realizar el pedido
    async makeOrder(type) {
      if (this.isFormValid) {
        this.selectOrderType = false;
        this.cargando = true;
        try {
          const payload = {
            // partner_id: 70, //borrar
            partner_id: this.getPartnerId(),
            articles: this.articles,
            tag_name: "PORTAL",
            type: type,
            order_reference: `${ this.userName }${ this.orderReference? ` ${this.orderReference}` : "" }`,
            order_note: this.orderNotes,
            to: jwtDecode(localStorage.getItem("token")).email,
            in_observation: this.showAlert,
          };
          console.log("Productos: ", payload);
          const { sale_order_id: sale_order_id } = await this.postDataWithReturn({ path: "django/portal/make_order/", body: payload });
          // console.log(sale_order_id);

          //desplegar dialog correcto
          this.dialog = true;
          this.error_text = "Pedido realizado correctamente";
          this.alertType = "success";

          //para saber que hay nuevos pedidos
          this.changeNewOrder(true);

          //vaciamos el carrito
          this.clearCart();
        } catch(e) {
          //desplegar dialogo error
          console.error("Error al crear pedido: ", e);
          this.dialog = true;
          this.error_text = "Error al realizar pedido";
          this.alertType = "error";
        } finally {
          this.cargando = false;
        }
      }
    },
    imageSrc(item){
      return `data:image/png;base64,${item.image_1920}`;
    },
  },
};
</script>
<style scoped>
.grey.lighten-4 {
  background-color: #f8f9fa !important;
}

/* Tarjeta de producto */
.product-card {
  border: 1px solid #e0e0e0 !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
}

.product-card:hover {
  border-color: #1976d2 !important;
}

.out-of-stock {
  opacity: 0.8;
  border-left: 4px solid #ff5252 !important;
}

/* Selector de cantidad */
.quantity-selector {
  background: #ffffff;
  border: 1px solid #d1d1d1;
  max-width: 130px;
}

.qty-input {
  width: 40px;
  border: none;
  font-weight: bold;
  font-size: 0.9rem;
  color: #333;
}

.qty-input:focus {
  outline: none;
}

/* Divisores y bordes */
.border-right {
  border-right: 1px solid #eee;
}

@media (min-width: 960px) {
  .border-left-md {
    border-left: 1px solid #eee;
  }
}

/* Tipografías y efectos */
.tracking-wider {
  letter-spacing: 0.05em;
}

.italic {
  font-style: italic;
}

/* Barra de búsqueda */
.search-bar >>> .v-input__slot {
  padding-left: 20px !important;
}

.search-bar >>> input {
  font-size: 1.1rem;
}

/* Sombra personalizada para botón de acción */
.shadow-lg {
  box-shadow: 0 10px 20px rgba(0,0,0,0.15) !important;
}

/* Animación suave para la paginación */
.v-pagination >>> button {
  transition: all 0.2s;
}

.v-pagination >>> .v-pagination__item--active {
  box-shadow: 0 4px 10px rgba(25, 118, 210, 0.3);
}
</style>